import { render, staticRenderFns } from "./AddOuter.vue?vue&type=template&id=1115b010&scoped=true&"
import script from "./AddOuter.vue?vue&type=script&lang=js&"
export * from "./AddOuter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1115b010",
  null
  
)

export default component.exports